import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';

import {
  BASE_URL,
  LOGIN_PAGE_URL,
  X_HEADER_ID_NAME,
} from '@src/utils/constants';
import { sessionSetter } from '@utils/storage';
import { isPublicAuthPage, isTrackRoute } from '@utils/auth';

const DENIED_ACCESS_MESSAGE = 'Access denied';

export const headerIdConfigs = {
  payor: 'X-Payor-Id',
  member: 'X-Member-Id',
  user: 'X-User-Id',
  place: 'X-Place-Id',
  contractor: 'X-Contractor-Id',
  ride: 'X-Ride-Id',
  standingOrder: 'X-Standing-Order-Id',
};

type ErrorResponse = {
  message: string;
};

const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  credentials: 'include',
  prepareHeaders: (headers) => {
    const config = sessionSetter.getItem<Record<string, any>>(X_HEADER_ID_NAME);
    if (config) {
      Object.entries(config).forEach(([key, value]) => {
        const hKey = headerIdConfigs[key as keyof typeof headerIdConfigs];
        if (hKey && value) headers.set(hKey, String(value));
      });
    }
    return headers;
  },
});

export const baseQuerySample: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extra) => {
  const result = await baseQuery(args, api, extra);
  if (result.error?.status === 401) {
    const pathname = window.location.pathname;

    if (!isPublicAuthPage(pathname) && !isTrackRoute(pathname)) {
      window.location.href = LOGIN_PAGE_URL;
    }
  }
  if (
    result.error?.status === 403 &&
    (result.error.data as ErrorResponse)?.message === DENIED_ACCESS_MESSAGE
  ) {
    window.location.href = '/no-authorization';
  }
  return result;
};

export const clearFunctionReset = (backendData: any) => {
  if (!backendData) return {};
  return Object.fromEntries(
    Object.entries(backendData).map(([k, v]) => [k, v ?? ''])
  );
};
